export default "__VITE_ASSET__D5_bFBvy__"